import i18n from "i18next";
import { initReactI18next, withTranslation as orgWithTranslation } from "react-i18next";
import hoistNonReactStatics from "hoist-non-react-statics";

// Import MUI locales instead of Antd
import * as locales from '@mui/material/locale';
import * as  Helper from "./utils/Helper";

import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";

import AppConfig from "./config/AppConfig";
import StorageEngine from "./utils/StorageEngine";
import dayjs from "dayjs";

// For now we just use English
let lngCode = "en";

i18n
    // load translation using xhr -> see /public/locales
    .use(HttpBackend)
    // detect user language
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next
    .use(initReactI18next)
    .init({
        ns: Helper.getInitI18nNamespaces(),
        backend: {
            // for all available options read the backend"s repository readme file
            // loadPath: "/locales/{{lng}}/{{ns}}.json"
            loadPath: function(lngArray, nsArray) {
                var language = lngArray[0];
                var namespace = nsArray[0]

                // break namespace into words like screens.account.login
                // so that we can build folder path to load the file
                const nsWords = namespace.split(".");

                var folderPath = "";
                for (var i = 0; i < nsWords.length - 1; i++) {
                    folderPath = folderPath + nsWords[i] + "/";
                }

                var fileName = nsWords.length > 1 ? nsWords[nsWords.length - 1] : namespace;

                return AppConfig.PUBLIC_PREFIX + "i18n/" + folderPath + fileName + "." + language + ".json?v=" + AppConfig.APP_CLIENT_BUILD;
            }
        },
        fallbackLng: "en",
        // resources,
        lng: lngCode,

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
dayjs.locale(lngCode === "zh" ? "zh-cn" : lngCode);

/* Fix the withTranslation component static prop can not access issue */
function withTranslation(ns, options = {}) {
    return function Extend(WrappedComponent) {
        return hoistNonReactStatics(orgWithTranslation(ns, options)(WrappedComponent), WrappedComponent);
    };
}

function getCurrentLanguage() {
    return i18n.language;
}

/**
 * MUI internationalization
 * @link https://mui.com/material-ui/guides/localization/
 */
function getMuiLocale() {
    return i18n.language === "zh" ? locales.zhCN : locales.enUS;
}

function changeLanguage(lng) {
    i18n.changeLanguage(lng);
    StorageEngine(AppConfig.LANGUAGE_SETTING).save(lng);
    dayjs.locale(lng);
}

export { withTranslation, getCurrentLanguage, getMuiLocale, changeLanguage };
export default i18n;
